import { TableColumnDefinition } from '@antimatterhq/ui/types/TableColumnDefinition';
import {
  tableColumnDefinitionsWithSelection,
  tableColumnDefinitionsWithSortingDisabled,
  tableColumnDefinitionsWithFilteringDisabled,
} from '@antimatterhq/ui/utils/table/helpers';

export const baseDefinitions: TableColumnDefinition[] = [
  {
    id: 'id',
    title: 'Notable ID',
    width: 150,
  },
  {
    id: 'eventTime',
    title: 'First event time',
    width: 150,
  },
  {
    id: 'duplicates',
    title: 'Events count',
    width: 150,
  },
  {
    id: 'summary',
    title: 'Summary',
    width: 150,
  },
  {
    id: 'state',
    title: 'State',
    width: 240,
  },
  {
    id: 'severity',
    title: 'Severity',
    width: 150,
  },
  {
    id: 'edit',
    tooltip: false,
    title: '',
    width: 40,
    enableResize: false,
    enableFiltering: false,
    enableSorting: false,
    pinned: 'right',
  },
];

export const notablesTableColumnDefinitions =
  tableColumnDefinitionsWithSelection(
    tableColumnDefinitionsWithSortingDisabled(
      tableColumnDefinitionsWithFilteringDisabled(baseDefinitions),
    ),
  );
